
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class CsParaGrid extends Serenity.EntityGrid<CsParaRow, any> {
        protected getColumnsKey() { return CsParaColumns.columnsKey; }
        protected getDialogType() { return CsParaDialog; }
        protected getIdProperty() { return CsParaRow.idProperty; }
        protected getInsertPermission() { return CsParaRow.insertPermission; }
        protected getLocalTextPrefix() { return CsParaRow.localTextPrefix; }
        protected getService() { return CsParaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = [];
            
            return buttons;
        }
        protected createSlickGrid() {
            this.slickGrid = super.createSlickGrid();

            new Serenity.AutoColumnWidthMixin({
                grid: this
            });

            return this.slickGrid;
        }
    }
}